<template lang="pug">
base-container(content="详情页面")
  el-row(type="flex" :gutter="30" align="middle" )
    el-col.mr8(:span="10")
      common-card(card-title="视频详情", v-if="isShow")
        .video-content
            video-player.video-player.vjs-custom-skin(
              ref="videoPlayer",
              :playsinline="true",
              :options="playerOptions"
            )
    el-col.mr8(:span="8")
      common-card(card-title="用户图片" class="no-border")
        .avatar-container
          el-image(:src="videoDetail.avatar", v-show="videoDetail.avatar")
  el-row
    el-col(:span="10")
      .btn-container
        .btn-group(v-if="videoDetail.checkStatus === 2")
          el-button.none-border.mr8(
            @click="handleRefuse",
            type="text",
            size="small",
            plain
          ) 拒绝
          el-button.none-border(
            @click="handlePass",
            type="text",
            size="small",
            plain
          ) 通过
</template>

<script>
import { doVideoCheck } from "@/api/user";
const CONFIRM_PASS_TITLE = "确实要通过申请吗？";
const CONFIRM_REFUSE_TITLE = "确实要拒绝申请吗？";
const PAGE_VIDEO_ROUTER = "/user/video";

import { LOCAL_STORAGE_KEY_AUTH_VIDEO_ITEM } from "./const";
import CommonCard from "@/components/CommonCard";
import PageHeader from "@/components/PageHeader";
export default {
  name: "AuthVideoDetail",
  components: {
    CommonCard,
    PageHeader
  },
  data() {
    return {
      videoDetail: null,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "4:3", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: "/path/to/video.mp4", // 路径
            type: "video/mp4" // 类型
          }
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  created() {
    const item = window.localStorage.getItem(LOCAL_STORAGE_KEY_AUTH_VIDEO_ITEM);
    let videoDetail = JSON.parse(item) || "";
    this.videoDetail = videoDetail;
    this.videoDetail.avatar = $imgUrl+this.videoDetail.avatar
    console.log(videoDetail)
    this.playerOptions.sources = [
      {
        src: $imgUrl+videoDetail.url
      }
    ];
  },
  computed: {
    player() {
      this.$refs.videoPlayer.player;
    },
    isShow() {
      return this.videoDetail && this.videoDetail.url != "";
    }
  },
  methods: {
    handlePass() {
      const { id, mobile } = this.videoDetail;
      this.$confirm(CONFIRM_PASS_TITLE, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          doVideoCheck({ recordId: id, mobile, opt: 1 }).then(() => {
            this.$message({
              type: "success",
              message: "操作成功",
              onClose: () => {
                this.$router.push({ path: PAGE_VIDEO_ROUTER });
              }
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    handleRefuse() {
      const { id, mobile } = this.videoDetail;
      this.$confirm(CONFIRM_REFUSE_TITLE, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          doVideoCheck({ recordId: id, mobile, opt: 0 }).then(() => {
            this.$message({
              type: "success",
              message: "操作成功",
              onClose: () => {
                this.$router.push({ path: PAGE_VIDEO_ROUTER });
              }
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.none-border {
  border: 0;
  background-color: transparent !important;
}
.avatar-container {
  width: 200px;
  margin-left: 20px;
  margin-top: 15px;
}
.video-content {
  display: flex;
  flex-direction: column;
  margin-left: 40px;
  .btn-group {
    width: 10%;
    margin-top: 40px;
    justify-content: space-around;
    display: flex;
    margin-right: 10px;
  }
}
.btn-container {
  text-align: center;
  height: 45px;
  margin-top: 20px;
}
</style>
